import { useCallback, type SyntheticEvent } from "react";

export type InfiniteListScrollQuery = {
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
};

/**
 * @param endThresholdPx — treat the list as “near bottom” when within this many px of `scrollHeight`.
 *   Use a small positive value (e.g. 36) if padding/rounding prevents hitting the exact bottom.
 */
export const useInfiniteListScrollHandler = (
  infiniteQuery: InfiniteListScrollQuery,
  endThresholdPx: number = 0,
) =>
  useCallback(
    (event: SyntheticEvent) => {
      const el = event.currentTarget;
      if (
        el.scrollTop + el.clientHeight >= el.scrollHeight - endThresholdPx &&
        infiniteQuery.hasNextPage &&
        !infiniteQuery.isFetchingNextPage
      ) {
        infiniteQuery.fetchNextPage();
      }
    },
    [infiniteQuery, endThresholdPx],
  );
